/* MoreFeaturesLink.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExternalLink, LinkButton } from '@atlassian/mpac-primitives';
import { editionConstants, useSource } from '@atlassian/mpac-utils';
import { FEATURE_COUNT_FOR_DISPLAY } from './constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._k48p1nn1{font-weight:400}";
const _2 = "._vwz41ejb{line-height:var(--ds-space-300,24px)}";
const _ = "._y3gn1e5h{text-align:left}";
const {
  EDITIONS_TYPE,
  TEST_IDS
} = editionConstants;
const LinkButtonStyles = {
  textAlign: 'left',
  lineHeight: "var(--ds-space-300, 24px)",
  fontWeight: 400
};
const StyledExternalLink = forwardRef((_ref, __cmplr) => {
  let {
      as: C = ExternalLink,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gn1e5h _vwz41ejb _k48p1nn1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledExternalLink.displayName = 'StyledExternalLink';
}
export const MoreFeaturesLink = _ref2 => {
  let {
    editionDetails,
    onClick,
    href
  } = _ref2;
  const source = useSource();
  const editionName = EDITIONS_TYPE[editionDetails.type];
  const extraFeaturesCount = (editionDetails === null || editionDetails === void 0 ? void 0 : editionDetails.features.length) - FEATURE_COUNT_FOR_DISPLAY;
  const featureText = "feature".concat(extraFeaturesCount > 1 ? 's' : '');
  const linkText = "and ".concat(extraFeaturesCount, " more ").concat(featureText);
  const ariaLabel = "".concat(editionName, " plan, explore ").concat(extraFeaturesCount, " more ").concat(featureText);
  if (extraFeaturesCount < 1) {
    return null;
  }
  if (source === 'PRODUCT') {
    return /*#__PURE__*/_jsx(StyledExternalLink, {
      "aria-label": ariaLabel,
      href: href || '#',
      "data-testId": TEST_IDS.MORE_FEATURES_LINK,
      children: linkText
    });
  }
  return /*#__PURE__*/_jsx(LinkButton, {
    "aria-label": ariaLabel,
    style: LinkButtonStyles,
    onClick: onClick,
    "data-testId": TEST_IDS.MORE_FEATURES_BUTTON,
    children: linkText
  });
};